<template>
  <div class="date-filters">
    <date-picker
      :header="'מתאריך'"
      :orderCurDate="fromDate"
      :v-model="fromDate"
      @trigger-date-picker-update="$emit('update-from-date', $event)"
      :width="'150px'"
    >
      <div>
        <v-text-field
          class="flex-1-0 date-picker pr-2"
          hide-details="auto"
          color="#434343"
          prepend-inner-icon="mdi-calendar-start"
          :model-value="formattedDate(fromDate, 'מתאריך')"
          variant="plain"
          style="pointer-events: none"
        ></v-text-field>
      </div>
    </date-picker>
    <date-picker
      :header="'עד תאריך'"
      :orderCurDate="toDate"
      :v-model="toDate"
      :width="'150px'"
      @trigger-date-picker-update="$emit('update-to-date', $event)"
    >
      <div>
        <v-text-field
          class="flex-1-0 date-picker pr-2"
          hide-details="auto"
          prepend-inner-icon="mdi-calendar-end"
          :model-value="formattedDate(toDate, 'עד תאריך')"
          variant="plain"
          style="pointer-events: none"
        ></v-text-field>
      </div>
    </date-picker>
  </div>
</template>

<script>
import { dateToDisplay } from "@/dates";
import DatePicker from "../../components/UI/date-picker.vue";
export default {
  components: {
    DatePicker,
  },
  emits: ["update-to-date", "update-from-date"],
  props: ["fromDate", "toDate"],
  methods: {
    formattedDate(date, text) {
      if (!date) return text;
      return dateToDisplay(date);
    },
  },
};
</script>
<style lang="scss">
.date-filters {
  .v-field__input {
    padding: 0px 2px;
  }
  .v-field__prepend-inner {
    padding-top: 14px !important;
    padding-left: 10px;
  }
  .v-icon {
    color: $statusListColor !important;
    opacity: 1 !important;
  }
}
.mdi-calendar-start::before {
  -webkit-transform: scaleX(-1) !important;
  transform: scaleX(-1) !important;
}
.mdi-calendar-end::before {
  -webkit-transform: scaleX(-1) !important;
  transform: scaleX(-1) !important;
}
.v-input__control {
  .v-field--variant-plain {
    display: flex;
    flex-direction: row-reverse;
  }
}
.mdi-calendar-end::before,
.mdi-calendar-start::before {
  color: black !important;
}
</style>
<style scoped lang="scss">
.date-filters {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.button-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
}
</style>
